import gql from 'graphql-tag';

export const IntlLoyaltyRemovePersonalizedOffer = gql`
  mutation ctgLoyaltyRemovePersonalizedOffer(
    $loyaltyId: String!
    $offerId: String!
    $configId: String!
    $cognitoId: String!
    $reason: String!
    $comments: String
    $rbiOrderId: String
  ) {
    ctgLoyaltyRemovePersonalizedOffer(
      loyaltyId: $loyaltyId
      offerId: $offerId
      configId: $configId
      cognitoId: $cognitoId
      reason: $reason
      comments: $comments
      rbiOrderId: $rbiOrderId
    )
  }
`;
